import { render, staticRenderFns } from "./ColorField.vue?vue&type=template&id=cd96c382&scoped=true"
import script from "./ColorField.vue?vue&type=script&lang=js"
export * from "./ColorField.vue?vue&type=script&lang=js"
import style0 from "./ColorField.vue?vue&type=style&index=0&id=cd96c382&prod&lang=scss&scoped=true"
import style1 from "./ColorField.vue?vue&type=style&index=1&id=cd96c382&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd96c382",
  null
  
)

export default component.exports